import { createApplicationService } from "./base/applicationServiceBase";
import { API } from "api/axios.config";
import { useMemo } from "react";

const WORKTYPE_BASE = "/WorkTypes";

export const getAllWorkTypes = () => API.get(`${WORKTYPE_BASE}`);

export const editWorkType = (id, data) =>
  API.patch(`${WORKTYPE_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const addWorkType = (data) =>
  API.post(`${WORKTYPE_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getWorkTypesByDepartment = (departmentId) =>
  API.get(`/WorkTypes?departmentId=${departmentId}&active=true`);

const workTypeService = createApplicationService({
  name: "workTypes",
  apiFetchFn: getAllWorkTypes,
  apiAddFn: addWorkType,
  apiUpdateFn: editWorkType,
});

const workTypeReducer = workTypeService.reducer;
const getWorkTypes = workTypeService.getData;
const addWorkTypes = workTypeService.addData;
const updateWorkType = workTypeService.updateData;
const useWorkTypes = workTypeService.useData;

const getActiveWorkTypes = async () => {
  const workTypes = await getWorkTypes();
  return workTypes.filter((d) => d.active) || [];
};

const useActiveWorkTypes = () => {
  const { data, loading } = useWorkTypes();
  const activeWorkTypes = useMemo(() => data.filter((d) => d.active), [data]);
  return { data: activeWorkTypes, loading };
};

export {
  workTypeReducer,
  getWorkTypes,
  addWorkTypes,
  updateWorkType,
  useWorkTypes,
  getActiveWorkTypes,
  useActiveWorkTypes,
};
